// Extensions reconnues, reprises du dispatch de Content.jsx.
const EXTENSIONS = {
    image : ['apng','avif','gif','jpg','jpeg','jfif','pjpeg','pjp','png','svg','webp','bmp','ico','cur','tif','tiff'],
    video : ['mkv','avi','m2ts','mpg','mpeg','mp4','mov','wmv','flv','webm','mts','rm','mp2','mpv','3gp','3g2'],
    text  : ['txt','m3u','xml'],
    pdf   : ['pdf']
};

const BY_EXTENSION = new Map();
Object.keys(EXTENSIONS).forEach(kind => {
    EXTENSIONS[kind].forEach(extension => BY_EXTENSION.set(extension, kind));
});

// Type d'affichage d'un élément :
// 'folder' | 'image' | 'video' | 'text' | 'pdf' | 'file'.
//
// Renvoie un type et non un composant : c'est la seule partie du dispatch qui
// soit partageable, chaque front associant ensuite ce type à son propre rendu
// (une ligne Bootstrap côté web, une ligne FlashList côté mobile).
export function fileKind(element){
    if(element.type === 'folder'){ return 'folder'; }
    const extension = element.name.toLowerCase().split('.').pop();
    return BY_EXTENSION.get(extension) || 'file';
}

export function isViewable(element){
    const kind = fileKind(element);
    return kind === 'image' || kind === 'video' || kind === 'text' || kind === 'pdf';
}
